export default __webpack_public_path__ + "static/media/digital-empire-big-4@2x.89b7924b.png";